module.exports = __webpack_public_path__ + "static/media/M4.83281889.jpg";